export const REFRESH_ACCESS_TOKEN_TIMER_COOKIE_KEY =
  'refresh-access-token-timer';
